<template>
  <div class="layout">
    <vue-header/>
    <nuxt class="layout__inner"/>
    <vue-footer/>
  </div>
</template>

<script>
import VueHeader from '~/components/layout/header';
import VueFooter from '~/components/layout/footer';
import { ENVIRONMENT } from '~/app/shared/utils/consts';

export default {
  name: 'DefaultLayout',
  components: { VueHeader, VueFooter },
  created() {
    if (process.browser && process.env.ENV_NAME === ENVIRONMENT.PRODUCTION) {
      this.$liveChat.loadAndInitScript();
    }
  },
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: map-get($colors, default);

  &__inner {
    flex-grow: 1;
  }
}
</style>
